import { HttpRequest3fsc4149kgwfg as HttpRequest } from './HttpRequest.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpRequestClass;
function DefaultHttpRequest() {
  if (DefaultHttpRequestClass === VOID) {
    class $ {
      constructor(call, data) {
        this.y5x_1 = call;
        this.z5x_1 = data.s5o_1;
        this.a5y_1 = data.r5o_1;
        this.b5y_1 = data.u5o_1;
        this.c5y_1 = data.t5o_1;
        this.d5y_1 = data.w5o_1;
      }
      f5m() {
        return this.y5x_1;
      }
      ww() {
        return this.f5m().ww();
      }
      g5m() {
        return this.z5x_1;
      }
      h5m() {
        return this.a5y_1;
      }
      y2q() {
        return this.b5y_1;
      }
      e55() {
        return this.c5y_1;
      }
      z5l() {
        return this.d5y_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpRequest', VOID, VOID, [HttpRequest()]);
    DefaultHttpRequestClass = $;
  }
  return DefaultHttpRequestClass;
}
//region block: exports
export {
  DefaultHttpRequest as DefaultHttpRequest19v463zllbymg,
};
//endregion

//# sourceMappingURL=DefaultHttpRequest.mjs.map
